const parseNumberFromQueryParam = (param: string | null | undefined) => {
    return param ? parseInt(param, 10) : NaN;
};

export default parseNumberFromQueryParam;
